// extracted by mini-css-extract-plugin
export var bodyRow = "_d0-d";
export var cardColumns = "_d0-e";
export var ellipsesOverflow = "_d0-2";
export var flatBottomCorners = "_d0-3";
export var flatTopCorners = "_d0-4";
export var headerActionsDropdown = "_d0-f";
export var headerBottomRow = "_d0-c";
export var headerTopRow = "_d0-b";
export var orderDetailsWrapper = "_d0-0";
export var orderInfoContainer = "_d0-1";
export var productDetails = "_d0-9";
export var productImage = "_d0-5";
export var responsiveTable = "_d0-8";
export var shipmentContainer = "_d0-a";
export var tableBottomLeft = "_d0-6";
export var tableBottomRight = "_d0-7";
export var trackingLink = "_d0-g";